<template>
  <v-list v-if="broadcasts.length > 0">
    <BroadcastElement
      v-for="broad in broadcasts"
      :key="broad._id.$oid"
      mobile
      :broad="broad"
    />
  </v-list>
  <v-row v-else justify="center" class="mt-6 pb-6">
    <v-icon class="mr-2">mdi-chat</v-icon> Nessun Messaggio
  </v-row>
</template>

<script>
import BroadcastElement from "../desktop/broadcast_element.vue";
import moment from "moment";
export default {
  components: {
    BroadcastElement,
  },
  methods: {
    data(ts) {
      return moment.unix(ts).format("dddd DD MMM hh:mm");
    },
    stato_icona(text) {
      if (text == "error" || text == "failed") {
        return "mdi-close";
      } else if (text == "sent") {
        return "mdi-check";
      } else {
        return "mdi-check-all";
      }
    },
    colore_icona(text) {
      if (text == "error" || text == "failed") {
        return "red";
      } else if (text == "read") {
        return "blue";
      } else {
        return "grey";
      }
    },
    cliente(iva) {
      return this.$store.getters.get_cliente_by_iva(iva);
    },
  },
  computed: {
    broadcasts() {
      return this.$store.getters.get_broadcasts;
    },
  },
};
</script>
